var nrpDescription =
    '<div class="cabinDetail-box">'
    + '<div class="lineTitle">'
        + '<div class="lineTitle-line"></div>'
        + '收费退订'
    + '</div>'
    + '<div class="cabinDetail-txt">'
        + '<p style="color: #333;font-weight: bold;">收费退订取消政策</p>'
        + '<p>开航前<span class="blue">30</span>天（含）以外取消订单，将收取<span class="blue">1000人民币/人起</span>作为取消费用；享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为取消费用（不包括港务税费）</p>'
        + '<p>开航前第<span class="blue">29-8</span>天取消订单，收取船费<span class="blue">全款的50%</span>作为取消费用（不包括港务税费）；</p>'
        + '<p>开航前第<span class="blue">7-0</span>天取消订单，收取船费<span class="blue">全款的100%</span>作为取消费用（不包括港务税费）。</p>'
        + '<p>关于船或航次修改，乘客姓名及其他个人信息修改政策，请详见“预订政策-退改签说明”。</p>'
    + '</div>'
    + '</div>'

var rpDescription =
    '<div class="cabinDetail-box">'
    + '<div class="lineTitle">'
    + '<div class="lineTitle-line"></div>'
    + '常规退订'
    + '</div>'
    + '<div class="cabinDetail-txt">'
    + '<p style="color: #333;font-weight: bold;">常规退订取消政策</p>'
    + '<p>开航<span class="blue">45</span>天（不含）之前取消订单，可<span class="blue">全额退款</span>；</p>'
    + '<p>开航前第<span class="blue">45-30</span>天取消订单，将收取<span class="blue">1000人民币/人起</span>作为取消费用；享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为取消费用（不包括港务税费）</p>'
    + '<p>开航前第<span class="blue">29-8</span>天取消订单，收取船费<span class="blue">全款的50%</span>作为取消费用（不包括港务税费）；</p>'
    + '<p>开航前第<span class="blue">7-0</span>天取消订单，收取船费<span class="blue">全款的100%</span>作为取消费用（不包括港务税费）。</p>'
    + '<p>关于船或航次修改，乘客姓名及其他个人信息修改政策，请详见“预订政策-退改签说明”。</p>'
    + '</div>'
    + '</div>'

var sevenDayNrpSwitch = '<div class="cabinDetail-box">'
    + '<div class="lineTitle">'
    + '<div class="lineTitle-line"></div>'
    + '开航7天前免费退改'
    + '</div>'
    + '<div class="cabinDetail-txt">'
    + '<p class="cabinDetail-txt-bold">取消政策：</p>'
    + '<p>开航前第<span class="blue">8</span>天及以外取消订单，可<span class="blue">全额退款</span>；</p>'
    + '<p>开航前第<span class="blue">7</span>天及以内取消订单，收取船费<span class="blue">全款的50%</span>作为取消费用（不包括港务税费）。</p>'
    + '</div>'
    + '</div>';

var fortyEightHoursNrpSwitch = '<div class="cabinDetail-box">'
    + '<div class="lineTitle">'
    + '<div class="lineTitle-line"></div>'
    + '退改无忧'
    + '</div>'
    + '<div class="cabinDetail-txt">'
    + '<p class="cabinDetail-txt-bold">取消政策：</p>'
    + '<p>2022年03月31日（含）前预订2022年9月30日（含）前出发的“皇家加勒比国际游轮”品牌下的中国母港及海外航次可享受无忧退改计划。具体政策如下：</p>'
    + "<p>开航<span class='blue'>7</span>天（不含）前取消订单，可<span class='blue'>全额退款</span>；</p>"
    + "<p>开航<span class='blue'>2</span>天（不含）前改签航次，船票费用及港务税费的差价将遵循多退少补原则，不收取额外的改签费用，可以改签至2022年间出发的中国母港及海外航次；</p>"
    + "<p>开航<span class='blue'>2</span>天（不含）前取消订单，可获得港务税费<span class='blue'>全额退款</span>，以及与游轮公司实收船票费用（不含港务税费）等额的未来航次抵用金※</p>"
    + "<p>开航<span class='blue'>2</span>天内取消订单，收取船票<span class='blue'>费用的100%</span>作为取消费用（不包括港务税费）。</p>"
    + "<p>针对<strong>香港出发海上游航次</strong>的无忧退改计划，请点击查看<a href='https://www.royalcaribbean.com/hkg/zh/cruise-with-confidence' target='_blank'>具体政策</a>。(https://www.royalcaribbean.com/hkg/zh/cruise-with-confidence)</p>"
    + "<p><strong>※未来航次抵用金（下称“抵用金”）使用规则：</strong></p>"
    + "<p>1、  通过“皇家加勒比国际游轮”中国大陆地区的官方渠道及合作旅行社，新预订2022年9月30日（含）前出发的“皇家加勒比国际游轮”品牌下的中国母港及海外航次，可使用抵用金，具体航次和舱房以预订当时的在售情况和实际库存为准。</p>"
    + "<p>2、  抵用金仅限本人（即抵用金凭证所载的持有人）为出行客人时使用，请在预订时出示抵用金凭证。</p>"
    + "<p>3、  抵用金只能抵扣游轮船票费用，不能抵扣船票费用以外的任何其他费用，如港务税费、游轮服务费、岸上观光费用等。</p>"
    + "<p>4、  如果抵用金金额大于新预订船票的价格，差额部分将重新签发一张等值额度的未来航次抵用金。</p>"
    + "<p>5、  抵用金不能兑换成现金、不可转让、不可抵扣订金或定金。</p>"
    + "<p>6、  每位乘客每个航次仅限使用一张未来航次抵用金。</p>"
    + "<p>7、  若此抵用金需要兑换成美金抵扣船票的，汇率以抵用当日中国人民银行公布的人民币兑换美元的中间价位准。</p>"
    + "<p>8、  抵用金凭证所载使用规则如与本规则有冲突的，以凭证所载使用规则为准。</p>"
    + "<p>9、  皇家加勒比国际游轮对抵用金的使用保留解释权。</p>"

    + "<p class='fortyEightHoursNrpSwitchTips'>关于船或航次修改，乘客姓名及其他个人信息修改政策，请详见本页-退改签说明。</p>"
    + "</div>"
    + "</div>";


export default {
    nrp: {
        title: '收费退订',
        priceType: '早订特惠价',
        description: nrpDescription
    },
    rp: {
        title: '常规退订',
        priceType: '优惠价',
        description: rpDescription
    },
    sevenDayNrp: {
        title: '开航7天前免费退改',
        priceType: '优惠价',
        description: sevenDayNrpSwitch
    },
    fortyEightHoursNrp: {
        title: '退改无忧',
        priceType: '优惠价',
        description: fortyEightHoursNrpSwitch
    }
}
